import {DisputesList} from "./disputes-list/disputes-list";

export const DisputesStack = {
    DisputesListPage: DisputesList
}